// imports
import Highway from '@dogstudio/highway/src/highway';
import { gsap } from 'gsap/all';
import { runFrontAnimation } from '../animations/frontAnimation';
// private statics

// class
export default class HighwayTransitions extends Highway.Transition {
    // constructor
    constructor (...args) {
        super(...args);
    }

    // methods
    in ({
        from, to, trigger, done,
    }) {
        // console.log('In');

        if (from) from.remove();

        if (!runFrontAnimation()) {
            // delay is required for certain inits
            gsap.fromTo(to, {
                y:       50,
                opacity: 0,
            }, {
                y:        0,
                opacity:  1,
                ease:     'sine-in',
                duration: 0.5,
                delay:    0.25,
            });
        }

        // don't wait
        done();
    }

    out ({ from, trigger, done }) {
        // console.log('Out');

        gsap.fromTo(from, {
            opacity: 1,
        }, {
            opacity: 0, ease: 'sine-in', duration: 0.5, onComplete: done,
        });
    }
}

// events
